import { FC } from 'react';
import { ButtonWrapper } from './ButtonEntry.styles';

export type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
};

const ButtonEntry: FC<React.PropsWithChildren<Props>> = ({ nodeData }) => {
    return (
        <ButtonWrapper
            href={nodeData?.data.target.fields.buttonUrl}
            variant={nodeData?.data.target.fields.category}
            data-type={nodeData?.data.target.fields.category}
            title={nodeData?.data.target.fields.buttonLabel}
            aria-label={nodeData?.data.target.fields.buttonLabel}
        >
            {nodeData?.data.target.fields.buttonLabel}
        </ButtonWrapper>
    );
};

export default ButtonEntry;
